import SpinnerLoader from "@/components/SpinnerLoader";
import { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";

const Loadable = (Component) => (props) =>
(
  <Suspense fallback={<SpinnerLoader />}>
    <Component {...props} />
  </Suspense>
);

const EventsTicketDetail = Loadable(
  lazy(() => import("./pages/EventTicketDetail"))
);
const EventsListPage = Loadable(lazy(() => import("./pages/EventsListPage")));
const EventsTicketAddPage = Loadable(
  lazy(() => import("./pages/EventsTicketAddPage"))
);
const EventsDetailPage = Loadable(
  lazy(() => import("./pages/EventsDetailPage"))
);
const EventsThanksPage = Loadable(
  lazy(() => import("./pages/EventsThanksPage"))
);
const EventsTicketCancel = Loadable(
  lazy(() => import("./pages/EventsTicketCancel"))
);
const EventsMyTicket = Loadable(lazy(() => import("./pages/EventsMyTicket")));
const LoadingFallback = () => <div className="p-4 text-center">Loading...</div>;

const eventsRoutes = [
  {
    path: "events",
    children: [
      {
        index: true,
        element: <Navigate to="7" replace />,
      },
      {
        path: ":category_id",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <EventsListPage />
          </Suspense>
        ),
      },
      {
        path: "add-ticket",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <EventsTicketAddPage />
          </Suspense>
        ),
      },
      {
        path: "detail/:service_id",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <EventsDetailPage />
          </Suspense>
        ),
      },
      {
        path: "thanks",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <EventsThanksPage />
          </Suspense>
        ),
      },
      {
        path: "my-ticket/*",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <EventsMyTicket />
          </Suspense>
        ),
      },
      {
        path: "cancel-booking",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <EventsTicketCancel />
          </Suspense>
        ),
      },
      {
        path: "booking-detail/:booking_id",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <EventsTicketDetail />
          </Suspense>
        ),
      },
    ],
  },
];

export default eventsRoutes;
